import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { carouselStyle } from "../Carousel/Carousel.css";

export const cardContainerStyle = style({
  overflow: "hidden",
  selectors: {
    [`${carouselStyle} &`]: {
      width: rem(356),
    },
  },
});

export const contentStyle = style({
  alignItems: "center",
  padding: theme.spacings.l,
  textAlign: "center",
});

export const hiddenInputStyle = style({
  display: "none",
});
